import { Cell } from "./Cell";

export class Row {
  constructor(public cells: Cell[]) {
  }

  public updateSelectStatusOfCells(isSelected: boolean) {
    for (const cell of this.cells) {
      cell.isSelected = isSelected;
    }
  }

  public get isSelected() {
    for (const cell of this.cells) {
      if (cell.isSelected) { return true; }
    }
    return false;
  }

  clone(): Row {
    const cells: Cell[] = [];
    for (const cell of this.cells) {
      cells.push(cell.clone());
    }
    return new Row(cells);
  }

  destroy(): void {
    this.cells = [];
  }
}
